import { render, staticRenderFns } from "./downExit.vue?vue&type=template&id=464d04ac&scoped=true&"
import script from "./downExit.vue?vue&type=script&lang=js&"
export * from "./downExit.vue?vue&type=script&lang=js&"
import style0 from "./downExit.vue?vue&type=style&index=0&id=464d04ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464d04ac",
  null
  
)

export default component.exports